import Vue from "vue"
import VueMonthlyPicker from "vue-monthly-picker"

Vue.component("VueMonthlyPicker", VueMonthlyPicker)
